<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="mw-970 mx-auto">
                    <div class="c-section">
                        <div>
                            <h2 class="c-ttl c-ttl--mdp fw-b">
                                Your trip summary
                            </h2>

                            <p class="cl-dark mt-2 fs-14">
                                Please check all the details below before proceeding with the payment.
                            </p>
                        </div>

                        <div class="o-bk-box box-sh bg-white is-rounded mt-4">
                            <table class="o-bk-table w-100">
                                <thead>
                                    <tr>
                                        <th colspan="3">
                                            Boat trip
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Outward</span>
                                            <span>{{ getPortById(legs.out.origin).name }}</span>
                                            <span class="icon-arrow-right-alt cl-sec-l mx-2 fs-10"></span>
                                            <span class="fw-sb">{{ getPortById(legs.out.destination).name }}</span>
                                        </td>

                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Date</span>
                                            <span>{{ getDeparture('out').format('ddd DD MMM') }}</span>
                                        </td>

                                        <td>
                                            <div class="d-flex">
                                                <div>
                                                    <span class="d-block fw-r fs-14 mb-2">Departure</span>
                                                    <span>{{ getDeparture('out').format('HH:mm') }}</span>
                                                </div>

                                                <div class="pl-4">
                                                    <span class="d-block fw-r fs-14 mb-2">Arrival</span>
                                                    <span>{{ getArrival('out').format('HH:mm') }}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="is-separator" colspan="3"></td>
                                    </tr>
                            
                                    <tr>
                                        <td colspan="2">
                                            <span class="d-block fw-r fs-14 mb-2">Tickets</span>
                                            <span>{{ totalPassengers }} x {{ specialOffer ? specialOffer.title : 'Standard price' }}</span>
                                        </td>

                                        <!--<td>
                                            <span class="d-block fw-r fs-14 mb-2">Options</span>

                                            <span>
                                                <span class="mr-2" :class="{
                                                    'cl-red': quote.non_refundable,
                                                    'cl-green': !quote.non_refundable
                                                }">{{ quote.non_refundable ? 'Non refundable' : 'Refundable' }}</span>
                                                <span
                                                    class="icon-questionmark-filled js-refund-tooltip"
                                                    data-tippy-content="Please check our Cancellation policy in the <em>&quot;Amend and cancel a booking&quot;</em> section"></span>
                                            </span>
                                        </td>-->

                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Class</span>
                                            <span>{{ accommodationClass == 'STD' ? 'Standard' : accommodationClass }}</span>
                                        </td>
                                    </tr>

                                    <template v-if="ticket != 'oneway'">
                                        <tr>
                                            <td class="is-separator" colspan="3"></td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Return</span>
                                                <span>{{ getPortById(legs.ret.origin).name }}</span>
                                                <span class="icon-arrow-right-alt cl-sec-l mx-2 fs-10"></span>
                                                <span class="fw-sb">{{ getPortById(legs.ret.destination).name }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Date</span>
                                                <span>{{ getDeparture('ret').format('ddd DD MMM') }}</span>
                                            </td>

                                            <td>
                                                <div class="d-flex">
                                                    <div>
                                                        <span class="d-block fw-r fs-14 mb-2">Departure</span>
                                                        <span>{{ getDeparture('ret').format('HH:mm') }}</span>
                                                    </div>

                                                    <div class="pl-4">
                                                        <span class="d-block fw-r fs-14 mb-2">Arrival</span>
                                                        <span>{{ getArrival('ret').format('HH:mm') }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        
                                        <tr>
                                            <td class="is-separator" colspan="3"></td>
                                        </tr>

                                        <tr>
                                            <td colspan="2">
                                                <span class="d-block fw-r fs-14 mb-2">Tickets</span>
                                                <span>{{ totalPassengers }} x {{ specialOffer ? specialOffer.title : 'Standard price' }}</span>
                                            </td>

                                            <!--td>
                                                <span class="d-block fw-r fs-14 mb-2">Options</span>

                                                <span class="js-tooltip"
                                                    :data-tippy-content="quote.non_refundable ? 'This ticket is non refundable' : 'This ticket is refundable'"
                                                    data-tippy-placement="bottom">
                                                    <span class="mr-2" :class="{
                                                        'cl-red': quote.non_refundable,
                                                        'cl-green': !quote.non_refundable
                                                    }">{{ quote.non_refundable ? 'Non refundable' : 'Refundable' }}</span>
                                                    <span
                                                        class="icon-questionmark-filled js-refund-tooltip"
                                                        data-tippy-content="Please check our Cancellation policy in the <em>&quot;Amend and cancel a booking&quot;</em> section"></span>
                                                </span>
                                            </td-->

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Class</span>
                                                <span>{{ accommodationClass == 'STD' ? 'Standard' : accommodationClass }}</span>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                            
                            <table class="o-bk-table w-100" v-if="transfer">
                                <thead>
                                    <tr>
                                        <th colspan="3">
                                            Transfer service
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Pick up point</span>
                                            <span>{{ transfer.name }}</span>
                                        </td>

                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Date</span>
                                            <span>{{ getDeparture('out').format('ddd DD MMM') }}</span>
                                        </td>

                                        <td>
                                            <div>
                                                <span class="d-block fw-r fs-14 mb-2">Time</span>
                                                <span>{{ transfer.time }}</span>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td class="is-separator" colspan="3"></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Pick up point</span>
                                            <span>{{ getPortById(legs.ret.destination).name }}</span>
                                        </td>

                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Date</span>
                                            <span>{{ getArrival('ret').format('ddd DD MMM') }}</span>
                                        </td>

                                        <td>
                                            <div>
                                                <span class="d-block fw-r fs-14 mb-2">Time</span>
                                                <span>{{ getArrival('ret').format('HH:mm') }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table class="o-bk-table w-100">
                                <thead>
                                    <tr>
                                        <th colspan="4">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="pr-2">
                                                    Passengers
                                                </div>
                                                
                                                <div class="text-right">
                                                    <button class="c-link is-rev cl-sec-l txt-init fw-r" type="button" @click="editPassengers">Modify information</button>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <template v-for="(passenger, index) in passengers">
                                        <tr v-bind:key="'separator_'+index" v-if="index">
                                            <td class="is-separator" colspan="3"></td>
                                        </tr>

                                        <tr v-bind:key="'passenger_'+index">
                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Passenger {{ index + 1 }}</span>
                                                <span class="txt-upper">{{ passenger.name }} {{ passenger.surname }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Country of nationality</span>
                                                <span>{{ getCountryName(passenger.nationality) }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Date of birth</span>
                                                <span>{{ $moment(passenger.dateOfBirth).format('DD/MM/YYYY') }}</span>
                                            </td>

                                            <td>
                                                <span class="d-block fw-r fs-14 mb-2">Document</span>
                                                <span>
                                                    {{ passenger.documentType == 'I' ? 'ID Card' : 'Passport' }}
                                                    {{ passenger.documentNumber }}
                                                </span>
                                            </td>
                                        </tr>

                                        <tr v-bind:key="'footer_'+index">
                                            <td class="is-info bg-sec-light-hover" colspan="4">
                                                <template v-if="luggageInfo.free && passenger.category != 'inf'">
                                                {{ luggageInfo.free }} check-in luggage included in your ticket
                                                </template>
                                                <template v-else>
                                                &nbsp;
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>

                            <table class="o-bk-table w-100">
                                <thead>
                                    <tr>
                                        <th colspan="4">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="pr-2">
                                                    Principal contact
                                                </div>

                                                <div class="text-right">
                                                    <button class="c-link is-rev cl-sec-l txt-init fw-r" type="button" @click="editPassengers">Modify information</button>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Email</span>
                                            <span>{{ email }}</span>
                                        </td>

                                        <td>
                                            <span class="d-block fw-r fs-14 mb-2">Phone</span>
                                            <span>{{ phone }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="o-bk-box__to-edge bg-sec-light-hover">
                                <strong class="fs-18">Your voyage cost</strong>
                            </div>

                            <div class="mt-4">
                                <ul class="o-bk-list-separator">
                                    <li v-for="(passengerItem, index) in passengerPrices" v-bind:key="index">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>
                                                {{ passengerItem.quantity }} x {{ passengerItem.category }} {{ quote.class.name }} ticket
                                            </span>

                                            <strong class="pl-2 text-right">
                                                {{ currency(passengerItem.total) }}
                                            </strong>
                                        </div>
                                    </li>

                                    <li v-if="quote.prices.luggage.quantity">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>
                                                {{ quote.prices.luggage.quantity }} x Extra Luggage
                                            </span>

                                            <strong class="pl-2 text-right">
                                                {{ currency(parseFloat(quote.prices.luggage.total.out) + parseFloat(quote.prices.luggage.total.ret || 0)) }}
                                            </strong>
                                        </div>
                                    </li>

                                    <li v-for="supplementItem in quote.prices.supplements" v-bind:key="supplementItem.supplement.id">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>
                                                {{ supplementItem.quantity }} x {{ supplementItem.supplement.name }}
                                            </span>

                                            <strong class="pl-2 text-right">
                                                {{ currency(parseFloat(supplementItem.total.out) + parseFloat(supplementItem.total.ret || 0)) }}
                                            </strong>
                                        </div>
                                    </li>

                                    <li v-if="transfer">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>
                                                {{ transfer.quantity }} x Transfer {{ transfer.name }}
                                            </span>

                                            <strong class="pl-2 text-right">
                                                {{ currency(parseFloat(transfer.total)) }}
                                            </strong>
                                        </div>
                                    </li>

                                    <!-- /*li>
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>
                                                1 x Adult Standard ticket winter sale offer applied
                                            </span>

                                            <strong class="pl-2 text-right">
                                                59,00 €
                                            </strong>
                                        </div>

                                        <div class="mt-1">
                                            <strong class="cl-red fw-m">
                                                Non refundable
                                            </strong>
                                        </div>
                                    </li*/ -->
                                </ul>

                                <!-- /*div class="p-2 p-md-3 mt-3 b1 is-rounded">
                                    Hai un codice promozionale? <a href="#" class="c-link is-rev cl-sec-l">Inseriscilo ora</a>
                                </div*/ -->
                            </div>

                            <div class="d-flex align-items-center justify-content-between my-5">
                                <strong class="c-ttl--mdp">
                                    Total
                                </strong>

                                <strong class="c-ttl--mdp cl-prim">
                                    {{ currency(quote.total) }}
                                </strong>
                            </div>

                            <p class="mb-0">
                                All prices quoted do not include access fee to Venice. <!--a href="#" class="c-link is-rev cl-sec-l">Read more</a-->
                            </p>
                        </div>

                        <!-- /*section class="o-bk-box box-sh bg-white is-rounded mt-3">
                            <div class="d-sm-flex align-items-center justify-content-between">
                                <div>
                                    <div class="o-bk-box__title d-flex align-items-center">
                                    <span
                                        class="icon-document is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
                                        <h3 class="c-ttl c-ttl--mdp ml-3">Billing details</h3>
                                    </div>
                                </div>

                                <div class="mt-4 mt-sm-0">
                                    <a class="btn btn-white-alt-sec-l is-smaller" href="#">Add billing</a>
                                </div>
                            </div>
                        </section*/ -->

                        <section class="o-bk-box box-sh bg-white is-rounded mt-3">
                            <div class="d-sm-flex align-items-center justify-content-between">
                                <div>
                                    <div class="o-bk-box__title d-flex align-items-center">
                                    <span
                                        class="icon-credit-card is-square-icon is-rounded bg-sec-light-hover cl-sec-l"></span>
                                        <h3 class="c-ttl c-ttl--mdp ml-3">Payment</h3>
                                    </div>
                                </div>

                                <div class="cl-dark fs-14 d-flex justify-content-end mb-4 mb-sm-0">
                                    <span class="pt-1">Secure payment</span><span class="icon-lock ml-2 fs-20"></span>
                                </div>
                            </div>

                            <p>Once you press the button “CONTINUE” you are authorising Venezia Lines to take the funds from your account at the amount stipulated above. We please ask you to be patient and do not close your browser or refresh the page.</p>
                            
                            <p>Once the payment is received you should be redirected to a confirmation page displaying your reservation number, here you can view, print and save your travel tickets. You should also receive an email with the tickets attached (<em>we please also ask you to check your junk folder since the emails may end up in this folder for reasons which are beyond our control</em>).</p>

                            <p>If for any reason you are not redirected to the confirmation page we please ask you <strong><u>NOT</u></strong> to make another booking but to contact Venezia Lines on <a href="mailto:sales@venezialines.com">sales@venezialines.com</a>, you should receive a reply within maximum 48 hours.</p>

                            <div class="alert alert-warning" v-if="paymentStatus">{{ paymentStatusText }}</div>

                            <div v-if="paymentStatus" class="text-center">
                                <button type="button" class="btn btn-white-alt-sec bg-white is-wide mr-3 mb-3" @click="clearStatus">Try again</button>
                            </div>

                            <!-- /*
                            <div class="o-bk-pay-form cl-dark">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="bookPayCardNumber">Card number</label>
                                            <div class="c-credit-cards">
                                                <input id="bookPayCardNumber" class="form-control" type="number">
                                                
                                                <div class="c-credit-cards__cards">
                                                    <img src="assets/media/icons/card-visa.svg" alt="Visa" height="28">
                                                    <img src="assets/media/icons/card-mastercard.svg" alt="Mastercard" height="28">
                                                    <img src="assets/media/icons/card-maestro.svg" alt="Maestro" height="28">
                                                    <img src="assets/media/icons/card-american.svg" alt="American Express" height="28">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="bookPayExpiryDate">Expiry date</label>
                                            <input id="bookPayExpiryDate" class="form-control" type="text">
                                        </div>
                                    </div>

                                    <div class="col-6">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="bookPaySecureCode">CVV/CVC</label>
                                            <input id="bookPaySecureCode" class="form-control" type="number">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="bookPayNameOnCard">Name on card</label>
                                            <input id="bookPayNameOnCard" class="form-control" type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="mb-1 fw-r d-block" for="bookPayEmail">Email address</label>
                                            <input id="bookPayEmail" class="form-control" type="email">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 mt-3">
                                        <form method="post">
                                            <button class="btn btn-primary w-100" type="submit" name="action" value="pay">
                                                Pay now  echo number_format($quote->total, 2, ',', ''); €
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            */ -->
                            <iframe v-if="!paymentStatus" height="600" width="100%" :src="paymentLink" style="border:none" class="mt-3" @load="iframeLoaded"></iframe>

                            <loader v-if="loading"></loader>
                        </section>
                        <!--div class="d-md-flex align-items-center justify-content-between mt-4 pt-2">
                            <button type="button" class="btn btn-white-alt-sec bg-white is-wide mr-3 mb-3" @click="previousStep">Back</button>
                        </div-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Loader from '../components/Loader.vue'
import countries from '../constants/countries'
import tippy from 'tippy.js'
export default {
  components: { Loader },
    data() {
        return {
            paymentLink: null,
            paymentStatus: null,
            loading: false,
        }
    },
    computed: {
        ...mapState('booking', [
            'legs',
            'ticket',
            'passengers',
            'passengersCount',
            'accommodationClass',
            'phone',
            'email',
            'specialOffer',
            'luggageInfo',
            'quote',
        ]),
        ...mapGetters([
            'getPortById',
        ]),
        ...mapGetters('booking', [
            'getDeparture',
            'getArrival',
        ]),
        totalPassengers() {
            return Object.values(this.passengersCount).reduce((a, b) => a + b, 0)
        },
        passengerPrices() {
            let prices = {}

            this.quote.prices.passengers.forEach(passenger => {
                let discount = parseFloat(passenger.discount.out) + parseFloat(passenger.discount.ret || 0)
                let total = parseFloat(passenger.total.out) + parseFloat(passenger.total.ret || 0)

                let key = passenger.category.code + (discount > 0 ? '_discount' : '')

                if (!prices[key]) {
                    prices[key] = {
                        category: passenger.category.name,
                        quantity: 0,
                        total: 0,
                        discount: 0,
                    }
                }

                prices[key].quantity += 1
                prices[key].total += total
                prices[key].discount += discount
            })

            return prices
        },
        paymentStatusText() {
            let text = {
                CANCEL: 'Your payment has been cancelled.',
                DECLINED: 'Your payment was declined.',
                default: 'There was an error processing your payment.',
            }

            return this.paymentStatus ? text[this.paymentStatus] : text.default
        },
        transfer() {
            if (!this.quote.prices.transfers.length) return false

            return {
                name: this.quote.prices.transfers[0].name,
                time: this.quote.prices.transfers[0].time,
                total: this.quote.prices.transfers.reduce((total, transfer) => total += transfer.total, 0),
                quantity: this.quote.prices.passengers.length,
            }
        }
    },
    mounted() {
        const self = this
        this.$scrollTo('body')
        let search = new URLSearchParams(window.location.search)
        this.paymentStatus = search.get('status')
        if (!this.paymentStatus) {
            this.getPaymentLink()
        } else {
            history.replaceState(null, document.title, window.location.href.split('?')[0])
        }
        if (window.self !== window.top) {
            this.paymentLink = null
            window.top.location.href = window.location.href
        }
        tippy('.js-refund-tooltip', {
            placement: 'bottom',
            allowHTML: true,
        })
    
        this.track({
            event: 'checkout'
        })

        window.addEventListener('message', function (event) {
            if (event.origin != window.location.protocol+'//'+window.location.host) {
                return false
            }

            if (
                typeof event.data === 'object' &&            
                !Array.isArray(event.data) &&
                event.data !== null
            ) {
                if (event.data.number && event.data.signature) {
                    self.track({ ecommerce: null })
                    self.track({
                        event: "purchase",
                        ecommerce: {
                            transaction_id: event.data.number,
                            value: self.quote.total,
                            currency: 'EUR',
                            special_offer: self.specialOffer?.name || '',
                            trip_type: self.ticket == 'return' ? (self.legs.ret.date == self.legs.out.date ? 'Venice day trip' : 'Return') : 'One way',
                            date: self.legs.out.date,
                            from: self.getPortById(self.legs.out.origin).name,
                            to: self.getPortById(self.legs.out.destination).name,
                            return_date: self.ticket == 'return' ? self.legs.ret.date : '',
                            return_from: self.ticket == 'return' ? self.getPortById(self.legs.out.origin).name : '',
                            return_to: self.ticket == 'return' ? self.getPortById(self.legs.out.destination).name : '',
                            passengers: JSON.parse(JSON.stringify(self.passengersCount))
                        },
                    })
                    setTimeout(function() {
                        window.location.assign(window.location.href.split('?')[0]+'?number='+event.data.number+'&signature='+event.data.signature)
                    }, 500)
                }
                else if (event.data.paymentStatus) {
                    self.paymentStatus = event.data.paymentStatus
                    self.paymentLink = null
                }
            }
        }, false)
    },
    methods: {
        ...mapActions('booking', [
            'previousStep',
            'restart',
        ]),
        ...mapMutations('booking', [
            'setStep',
            'setApiError'
        ]),
        getPaymentLink() {
            this.loading = true
            this.$api.paymentLink().then(response => {
                if (response.url) {
                    this.paymentLink = response.url
                }
                else {
                    this.restart()
                    if ((response.data && response.data.expired) || response.status == 404) {
                        this.setApiError('Your reservation has expired, please start again')
                    }
                }
            })
        },
        getCountryName(code) {
            let country = countries.find(country => country.alpha2.toLowerCase() == code.toLowerCase())
            return country ? country.name : '-'
        },
        editPassengers() {
            this.setStep('passengers')
        },
        clearStatus() {
            this.paymentStatus = null
            this.getPaymentLink()
        },
        iframeLoaded() {
            this.loading = false
        }
    }
}
</script>